const TOOLS = (count) => ({
    count,
    noun: 'tools',
    unit: 'tool',
    label: 'Tools',
});
const ENDPOINTS = (count) => ({
    count,
    noun: 'endpoints',
    unit: 'endpoint',
    label: 'Endpoints',
});
/** What this one connector exposes. */
export function connectorSurface(c) {
    return c.kind === 'mcp' ? TOOLS(c.tools?.length ?? 0) : ENDPOINTS(c.endpoints.length);
}
/**
 * What a catalog row exposes — one app, however many instances run under it.
 *
 * "Tools" only when every instance is an MCP server. An app running an MCP
 * server beside a REST connector exposes both, and there is no honest single
 * noun for that sum, so the row keeps the general one rather than picking the
 * kind that happens to sort first.
 */
export function appSurface(instances) {
    const allMcp = instances.length > 0 && instances.every((c) => c.kind === 'mcp');
    return allMcp
        ? TOOLS(instances.reduce((n, c) => n + (c.tools?.length ?? 0), 0))
        : ENDPOINTS(instances.reduce((n, c) => n + c.endpoints.length, 0));
}
//# sourceMappingURL=connector_surface.js.map